import axios from '@/api/config';

const subjectCourse = {
  // 专栏 获取录播接口 
  getGoodsInfoCenterByType(data){
    return axios.post(`${process.env.BASE_URL}/goodsInfoCenter/getGoodsInfoCenterByType`,data)
  },
  getPageList(data) {
    return axios.post(`${process.env.BASE_URL}/subjectCourse/pageList`, data);
  },
  addSubjectCourse(data) {
    return axios.post(`${process.env.BASE_URL}/subjectCourse/addSubjectCourse`, data);
  },
  updateSubjectCourse(data) {
    return axios.put(`${process.env.BASE_URL}/subjectCourse/updateSubjectCourse`, data);
  },
  offSubjectCourse(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/offSubjectCourse`, { params: data });
  },
  onSubjectCourse(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/onSubjectCourse`, { params: data });
  },
  getSubjectCourseListByPid(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/getSubjectCourseListByPid`, { params: data });
  },
  getSubjectCourse(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/getSubjectCourse`, { params: data });
  },
  getPListByLevel(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/getPListByLevel`, { params: data });
  },
}

export default subjectCourse;



// WEBPACK FOOTER //
// ./src/api/subjectCourse.js